/*!
 * Copyright (c) Trimble Inc. All rights reserved
 */
/* istanbul ignore file */
import { Component, OnInit, ViewChild, Input } from '@angular/core';
import { Router } from '@angular/router';
import { GenericTableData } from '../../sharedServices/generic-table-data.service';
import { RoutesPage } from '../../models/enums/RoutePage.enum';
import { NavService } from '../../sharedServices/nav.service';
import { Subject } from 'rxjs';
import { UserHandlerService } from '../../sharedServices/user-handler.service';
import { UserService } from 'api/services';
import { LoaderService } from '../../sharedServices/loader.service';
import { MatSidenav } from '@angular/material/sidenav';

@Component({
  selector: 'app-nav-component',
  templateUrl: './nav-component.component.html',
  styleUrls: ['./nav-component.component.css'],
})
export class NavComponentComponent implements OnInit {
  @ViewChild('sidenav', { static: true }) public nav: MatSidenav;
  showLoader: boolean;
  userPages;
  @Input() refreshNav: Subject<boolean> = new Subject<boolean>();
  opened = false;
  routersPage = RoutesPage;
  constructor(
    private readonly navService: NavService,
    private readonly userHandlerService: UserHandlerService,
    private readonly userService: UserService,
    private readonly router: Router,
    private readonly fittingDataService: GenericTableData,
    private readonly loaderService: LoaderService
  ) {
    this.userHandlerService.currentUserChanged.subscribe(() => {

      const currentUser = this.userHandlerService.getCurrentUser();
      if (currentUser) {
        this.userService.getPagesByUserAsync({ roleDto: currentUser.role }).subscribe(result => {
          this.userPages = result;
          this.loaderService.display(false);
        });
      }
    });
  }

  ngOnInit(): void {
    this.navService.setSidenav(this.nav);
    this.loaderService.status.subscribe((val: boolean) => {
      this.showLoader = val;
    });
  }
  navigatUserSettingsPage() {
    this.router.navigateByUrl('/app-user-settings-page');
  }

  resetSharedData() {
    this.fittingDataService.setTableDataList(null);
  }

  getIcon(pageId: number) {
    switch (pageId) {
      case 28: return 'ticons ticons-add_circle_outline';
      case 29: return 'ticons ticons-connections';
      case 30: return 'ticons ticons-update';
      case 31: return 'ticons ticons-swap_horiz';
      case 32: return 'ticons ticons-verified_user';
      case 33: return 'ticons ticons-home';
      case 34: return 'ticons ticons-users';
      case 35:
      case 36: return 'ticons ticons-sync_outline';
      case 37: return 'ticons ticons-cloud_download';
      case 38: return 'ticons ticons-cloud_upload';
      case 39: return 'ticons ticons-content_copy';
    }
  }
}
